import { render } from "./CompanyDetails.vue?vue&type=template&id=5d5be323"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=5d5be323&lang=css"
script.render = render

export default script